var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import ClientAccessValidationForm from "./ClientAccessValidationForm";
import { emailRegex } from "@frameworks/web/utils/regex";
import { getDateInFormat } from "@domains/utils/reportDates";
import "@frameworks/salesjourney/stylesheets/components/Features/PlaceOrder/ClientAccessControl.scss";
import clientDi from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { EValidateOptions, validationOptionErrors, } from "@frameworks/salesjourney/components/Features/PlaceOrder/AccessControl/constants";
/**
 * ClientAccessValidation
 *
 * This component is to validate the client before placing an order
 *
 * @param {IClientSearchEntity} clientDetails
 * @param {Boolean} visible
 * @param {Function} setVisible
 * @param {Function} callBackOnCancelClick
 * @param {Function} callBackOnVerifyClick

 * @returns {}
 */
var ClientAccessValidation = function (props) {
    // *******************************************
    // *           useStates                 *
    // *******************************************
    var _a = __read(useState(EValidateOptions.MOBILE), 2), selectedOption = _a[0], setSelectedOption = _a[1];
    var _b = __read(useState(""), 2), mobileNo = _b[0], setMobileNo = _b[1];
    var _c = __read(useState(null), 2), selectedDate = _c[0], setSelectedDate = _c[1];
    var _d = __read(useState(""), 2), email = _d[0], setEmail = _d[1];
    var _e = __read(useState(), 2), errors = _e[0], setErrors = _e[1];
    var _f = __read(useState(), 2), targetRowId = _f[0], setTargetRowId = _f[1];
    // *******************************************
    // *           GENERATOR FUNCTIONS           *
    // *******************************************
    // NA
    // *******************************************
    // *           HANDLER FUNCTIONS             *
    // *******************************************
    var handleValidateClient = function () {
        var validationValue = selectedOption === EValidateOptions.MOBILE
            ? "91".concat(mobileNo)
            : selectedOption === EValidateOptions.DATE_OF_BIRTH
                ? getDateInFormat(selectedDate, "DD-MM-YYYY")
                : selectedOption === EValidateOptions.EMAIL
                    ? email
                    : null;
        if (validationValue === null) {
            throw new Error("Invalid validation type or value.");
        }
        clientDi.clients
            .validateClient({
            ucc_code: props.clientDetails.uniqueCode,
            validationtype: selectedOption,
            validationvalue: validationValue,
        })
            .then(function (response) {
            var _a;
            var _b, _c, _d, _e, _f;
            var data = response === null || response === void 0 ? void 0 : response.data;
            if ((data === null || data === void 0 ? void 0 : data.length) <= 0) {
                setErrors(__assign(__assign({}, errors), (_a = {}, _a[selectedOption] = validationOptionErrors[selectedOption], _a)));
            }
            else {
                setEmail("");
                setMobileNo("");
                setSelectedDate(new Date());
                (_b = props.setToastDetails) === null || _b === void 0 ? void 0 : _b.call(props, {
                    msg: "Client details verified and added to the order list.",
                    isError: false,
                    isShow: true,
                });
                props === null || props === void 0 ? void 0 : props.callBackOnVerifyClick(__assign(__assign({}, props.clientDetails), { clientName: (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.acname, clientTier: (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.clienttier }), targetRowId);
                props.setVisible(false);
            }
        })
            .catch(function (error) {
            var _a;
            (_a = props.setToastDetails) === null || _a === void 0 ? void 0 : _a.call(props, {
                msg: "Client details not verified and not added to the order list.",
                isError: true,
                isShow: true,
            });
            props.callBackOnCancelClick();
        });
    };
    // *******************************************
    // *           Miscellaneous                 *
    // *******************************************
    var isButtonDisabled = function () {
        if (selectedOption === EValidateOptions.MOBILE && mobileNo.length < 10) {
            return true;
        }
        if (selectedOption === EValidateOptions.DATE_OF_BIRTH && !selectedDate) {
            return true;
        }
        if (selectedOption === EValidateOptions.EMAIL &&
            (!email || !emailRegex.test(email))) {
            return true;
        }
        return false;
    };
    // *******************************************
    // *           UseEffects                    *
    // *******************************************
    useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.targetRowId) {
            setTargetRowId(props.targetRowId);
        }
    }, [props === null || props === void 0 ? void 0 : props.targetRowId]);
    // *******************************************
    // *            Rendering                    *
    // *******************************************
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericSidebar, { parentClassname: "primary-client-access-validation-sidebar-container client-details-container d-flex flex-column", header: React.createElement("div", { className: "d-flex flex-row" },
                (props === null || props === void 0 ? void 0 : props.showBackArrow) && (React.createElement("i", { className: "edel-icon-left-shortArrow txt_white DMSans_20_300 mgr-10", onClick: props === null || props === void 0 ? void 0 : props.callBackOnCancelClick })),
                React.createElement("div", { className: "d-flex flex-column" },
                    React.createElement("p", { className: "DMSansMedium_15_500 txt_white client-access-validation-sidebar-header\n              " }, "Enter client details"),
                    React.createElement("p", { className: "txt-blue-light3 DMSanN_14_300 fw-light mb-0" }, "Client matching this PAN needs additional details"))), body: React.createElement(React.Fragment, null,
                React.createElement(ClientAccessValidationForm, { selectedOption: selectedOption, mobileNo: mobileNo, selectedDate: selectedDate, email: email, onSelectedOptionChange: setSelectedOption, onMobileNoChange: function (value) {
                        setMobileNo(value);
                    }, onSelectedDateChange: setSelectedDate, onEmailChange: setEmail, formErrors: errors, setFormErrors: setErrors, clientDetails: props.clientDetails })), footer: React.createElement("div", { className: "d-flex flex-wrap justify-content-around w-100 client-validation-footer" },
                React.createElement(EdButton, { onClick: function () {
                        props.setToastDetails({
                            msg: "Client details not verified and not added to the order list.",
                            isError: true,
                            isShow: true,
                        });
                        props.callBackOnCancelClick();
                    }, btnTyp: "link", value: "Cancel", className: "DMSans_16_500 client-validation-cancel-btn" }),
                React.createElement(EdButton, { onClick: handleValidateClient, btnTyp: "".concat(isButtonDisabled() ? "midnight-blue" : "tomato"), value: "Verify", className: "DMSans_16_500 client-validation-verify-btn", disabled: isButtonDisabled() })), openKey: props.visible, setOpenKey: props.setVisible, arrowClose: true, delay: 10, blurBackground: true, onSideBarClose: function () {
                props.setToastDetails({
                    msg: "Client details not verified and not added to the order list.",
                    isError: true,
                    isShow: true,
                });
                props === null || props === void 0 ? void 0 : props.callBackOnSideBarClose;
            } })));
};
export default ClientAccessValidation;
